import React from 'react';
import {
    Card,
    FormLayout,
    Select,
    TextField
} from '@shopify/polaris';

export function TagNewProductsSettings(props) {

    function onReferenceDateTypeChange(value) {

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.referenceDateType = value;
        props.onSettingsChange(newSettings);
    }

    function onNewProductTagChange(value) {

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.newProductTag = value;
        props.onSettingsChange(newSettings);
    }

    function onDaysSinceReferenceChange(value) {

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.daysSinceReference = value;
        props.onSettingsChange(newSettings);
    }

    return (
        <React.Fragment>
            <Card.Section title="Options">
                <FormLayout>
                    <Select
                        label="New Product Reference Type"
                        options={[
                            { label: 'Date created', value: 'DateCreated' },
                            { label: 'Date Published', value: 'DatePublished' },
                        ]}
                        onChange={onReferenceDateTypeChange}
                        value={props.settings.referenceDateType}
                        helpText={
                            <span>
                                Specifies how new products are determined.
                            </span>
                        }
                    />
                    <TextField
                        value={props.settings.daysSinceReference}
                        label="Threshold days"
                        type="number"
                        placeholder="Number of days"
                        error={props.settingsErrors["daysSinceReference"]}
                        onChange={onDaysSinceReferenceChange}
                        helpText={
                            <span>
                                {"Number of days since " + props.settings.referenceDateType + " that a product is considered new."}
                            </span>
                        }
                    />
                    <TextField
                        label="New Product Tag"
                        placeholder="Tag name"
                        helpText={
                            <span>
                                The tag to be applied to new products.
                            </span>
                        }
                        error={props.settingsErrors["newProductTag"]}
                        value={props.settings.newProductTag}
                        onChange={onNewProductTagChange}
                        autoComplete="off"
                    />
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );
}